import type { FC } from "react";
import React from "react";

import { Button } from "@react/ui-primitives/button";

import { useAuthRedirect } from "../hooks/useAuthRedirect.ts";

export const GoogleSigninButton: FC = () => {
  const { isPending, redirect } = useAuthRedirect();

  return (
    <Button disabled={isPending} onClick={redirect}>
      Sign in with Google
    </Button>
  );
};
